import { NotificationConfig, NotificationConfigType } from 'types/NotificationConfig'

const ORDER = [
  NotificationConfigType.FIRST_LOAD,
  NotificationConfigType.LAST_LOAD,
  NotificationConfigType.ORDERS_PLACED_ONLINE,
  NotificationConfigType.ORDERS_MODIFIED_ONLINE,
]
export function sortedNotificationConfigs(configs: NotificationConfig[]) {
  return configs.slice().sort((a, b) => {
    return ORDER.indexOf(a.type) < ORDER.indexOf(b.type) ? -1 : 1
  })
}
